import React, { useState } from 'react';
import { TournamentCard } from "../Tournament/TournamentCard";
import { NewsClient, NewsModel } from '../../utils/apiClient';
import axios from 'axios';
import ApiUrl from '../../utils/config';
import AppContext from '../../AppContext';
import { handleError } from '../../utils';

export const HomePage = () => {
  const appContext = React.useContext(AppContext);
  const [news, setNews] = useState<NewsModel | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const newsClient = new NewsClient(ApiUrl, axios);

  const getNews = async () => {
    try {
      setLoading(true);
      const response = await newsClient.getNews();
      setNews(response);
    } catch (ex) {
      handleError(appContext!.setNotificationData, ex);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    getNews();
  }, []);

  if (loading) {
    return <div>Loading news...</div>;
  }

  if (!news) {
    return <div>Ничего нового (просто загрузить новости не получилось вот и всё. Их нет.)</div>;
  }

  // const formatDate = (dateString: string) => {
  //   return new Date(dateString).toLocaleDateString();
  // };

  return (
    <div className="home-page">
      <section className="home-page__hero">
        <h2>Welcome to Judo Tournament Manager</h2>
        <p>Organize, manage, and participate in judo tournaments</p>
      </section>

      <section className="home-page__news-section">
        <h2>Tournament News</h2>

        <div className="home-page__tournament-section">
          <h3>Active Tournaments</h3>
          {news.activeTournaments && news.activeTournaments.length > 0 ? (
            <div className="home-page__tournament-grid">
              {news.activeTournaments.map((tournament) => (
                <TournamentCard key={tournament.id} tournament={tournament} />
              ))}
            </div>
          ) : (
            <p>No active tournaments</p>
          )}
        </div>

        <div className="home-page__tournament-section">
          <h3>Upcoming Tournaments</h3>
          {news.upcomingTournaments && news.upcomingTournaments.length > 0 ? (
            <div className="home-page__tournament-grid">
              {news.upcomingTournaments.map((tournament) => (
                <TournamentCard key={tournament.id} tournament={tournament} />
              ))}
            </div>
          ) : (
            <p>No upcoming tournaments</p>
          )}
        </div>

        <div className="home-page__tournament-section">
          <h3>Past Tournaments</h3>
          {news.pastTournaments && news.pastTournaments.length > 0 ? (
            <div className="home-page__tournament-grid">
              {news.pastTournaments.map((tournament) => (
                <TournamentCard key={tournament.id} tournament={tournament} />
              ))}
            </div>
          ) : (
            <p>No past tournaments</p>
          )}
        </div>
      </section>
    </div>
  );
};
